import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './cosmos-text2.js';
import { b as bem } from './bem.js';
import { t as transformTagName } from './transformTagName.js';

const cosmosOptgroupCss = ".cosmos-optgroup__label{--cosmos-text-color:var(--cosmos-optgroup-color);--cosmos-text-font-family:var(--cosmos-optgroup-font-family);--cosmos-text-font-size:var(--cosmos-optgroup-font-size);--cosmos-text-font-style:var(--cosmos-optgroup-font-style);--cosmos-text-font-weight:var(--cosmos-optgroup-font-weight);--cosmos-text-letter-spacing:var(--cosmos-optgroup-letter-spacing);--cosmos-text-line-height:var(--cosmos-optgroup-line-height);--cosmos-text-text-transform:var(--cosmos-optgroup-text-transform);padding:12px 12px 8px 12px}.cosmos-optgroup--disabled .cosmos-optgroup__label{--cosmos-text-color:rgba(0, 15, 30, 0.6)}.cosmos-optgroup--disabled.cosmos-optgroup--appearance-light .cosmos-optgroup__label{--cosmos-text-color:rgba(255, 255, 255, 0.6)}";
const CosmosOptgroupStyle0 = cosmosOptgroupCss;

const generateClassNames = bem('cosmos-optgroup');
const CosmosOptgroup$1 = /*@__PURE__*/ proxyCustomElement(class CosmosOptgroup extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.handleSlotChange = () => {
            this.initOptions();
        };
        this.appearance = 'dark';
        this.disabled = undefined;
        this.label = undefined;
    }
    initOptions() {
        if (this.disabled) {
            const options = Array.from(this.element.querySelectorAll(transformTagName('cosmos-option')));
            options.forEach((option) => {
                option.disabled = true;
            });
        }
    }
    componentWillLoad() {
        this.initOptions();
    }
    render() {
        return (h(Host, { role: "group", "aria-label": this.label }, h("div", { class: generateClassNames({ disabled: this.disabled, appearance: this.appearance }), part: "base" }, h("div", { class: generateClassNames('label') }, h("cosmos-text", { exportparts: "base: label", size: "x-small", weight: "medium", clamp: 1, appearance: this.appearance }, this.label)), h("slot", { onSlotchange: this.handleSlotChange }))));
    }
    get element() { return this; }
    static get style() { return CosmosOptgroupStyle0; }
}, [1, "cosmos-optgroup", {
        "appearance": [513],
        "disabled": [516],
        "label": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-optgroup", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-optgroup":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosOptgroup$1);
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosOptgroup = CosmosOptgroup$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosOptgroup, defineCustomElement };
